// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__zRZyl","mainwrapper":"Dashboard_mainwrapper__5QIRi","MainBoard":"Dashboard_MainBoard__ci9Dr"};